import { ShieldCheck, Clock, MapPin, Headset } from "lucide-react";
const indicators = [{
  icon: ShieldCheck,
  title: "— 'Exceptional local craftsmanship'"
}, {
  icon: Clock,
  title: "— 'Reliable service for years'"
}, {
  icon: MapPin,
  title: "— 'Central Coast's top trade team'"
}, {
  icon: Headset,
  title: "— 'Highly professional and efficient'"
}];
export default function IndicadoresDeConfianza() {
  return;
}